import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ErrorLabel } from '../../../../../components/ErrorLabel';
import { getAttr } from '../../../../../features/helpers/apiHelpers';

const noErrorsState = {
  nameIsEmpty: false,
  nameAlreadyExists: false,
};

export const useInvitationGroupValidator = (title, invitationGroups) => {
  const { t: translator } = useTranslation();

  const [errorState, setErrorState] = useState(noErrorsState);

  useEffect(() => {
    if (!title) {
      setErrorState((prev) => ({ ...prev, nameIsEmpty: true }));
    } else if (invitationGroups?.some((ig) => getAttr(ig, 'name') === title)) {
      setErrorState((prev) => ({ ...prev, nameAlreadyExists: true }));
    } else {
      setErrorState(noErrorsState);
    }
  }, [invitationGroups, title]);

  const renderValidationErrors = () => {
    if (errorState?.nameAlreadyExists) {
      return (
        <ErrorLabel>
          {translator(
            'pages.adminInvitationGroups.validationErrors.nameAlreadyExistsError',
          )}
        </ErrorLabel>
      );
    } else if (errorState?.nameIsEmpty) {
      return (
        <ErrorLabel>
          {translator(
            'pages.adminInvitationGroups.validationErrors.nameIsEmptyError',
          )}
        </ErrorLabel>
      );
    } else {
      return null;
    }
  };

  const validationFailed =
    errorState?.nameIsEmpty || errorState?.nameAlreadyExists;

  return {
    validationFailed,
    renderValidationErrors,
  };
};
